export function inset(value: number) {
  return {
    top: value,
    right: value,
    bottom: value,
    left: value
  };
}